import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "icon"]

  toggle(event) {
    const group = event.params.group
    if (!group) return

    const rows = this.rowTargets.filter((row) => row.dataset.group === group)
    if (rows.length === 0) return

    const shouldExpand = rows[0].classList.contains("hidden")
    rows.forEach((row) => row.classList.toggle("hidden", !shouldExpand))

    this.iconTargets
      .filter((icon) => icon.dataset.group === group)
      .forEach((icon) => {
        icon.textContent = shouldExpand ? "▾" : "▸"
      })

    event.currentTarget.setAttribute("aria-expanded", shouldExpand ? "true" : "false")
  }
}
